/**
 * @generated SignedSource<<7f6d9c357e48526b962c2950835ab260>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useStarredItems$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useStarredItemsPaged">;
  readonly " $fragmentType": "useStarredItems";
};
export type useStarredItems$key = {
  readonly " $data"?: useStarredItems$data;
  readonly " $fragmentSpreads": FragmentRefs<"useStarredItems">;
};

import useStarredItemsRefetchableQuery_graphql from './useStarredItemsRefetchableQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "kind": "RootArgument",
      "name": "filter"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [],
      "operation": useStarredItemsRefetchableQuery_graphql
    }
  },
  "name": "useStarredItems",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "count",
          "variableName": "count"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useStarredItemsPaged"
    }
  ],
  "type": "Query"
};

(node as any).hash = "b909e4d50c7f00b7a9e6847f3480bf16";

export default node;
